import React, { Component, MouseEvent } from 'react';
import { Link } from 'react-router-dom';
import logo from '../img/navbar-logo.png';
import { User, getUser } from '../helpers/user';
import { logOut } from '../helpers/login';

class HeaderProps { }

class HeaderState {
  open: boolean = false;
  user?: User | null;
}

class Header extends Component<HeaderProps, HeaderState> {

  constructor(props: HeaderProps) {
    super(props);
    this.state = {
        open: false,
        user: getUser()
    };
  }

  signOut = (e: MouseEvent<HTMLSpanElement>) => {
    e.preventDefault();
    logOut();
  }

  handleBurgerClick = (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
      e.preventDefault();
      this.setState({
          open: !this.state.open
      });
  };

  render() {
    return (
      <nav className="navbar is-light" role="navigation" aria-label="main navigation">
        <div className="navbar-brand">
          <Link to="/" className="navbar-item">
            <img src={logo} width="112" height="28" alt="Dashboard" />
          </Link>

          <button 
              onClick={this.handleBurgerClick}
              className={"navbar-burger burger" + (this.state.open ? ' is-active' : '')}
              aria-label="menu"
              aria-expanded="false"
              data-target="topLevelNavbar">
              <span aria-hidden="true"/>
              <span aria-hidden="true"/>
              <span aria-hidden="true"/>
          </button>
        </div>

        <div id="topLevelNavbar" className={"navbar-menu"}>
          <div className="navbar-start">

            <div className="navbar-item has-dropdown is-hoverable">
              <span className="navbar-link">Suppliers</span>

              <div className="navbar-dropdown">
                <Link to="/davidsons" className="navbar-item">Davidsons</Link>
                <Link to="/rsr" className="navbar-item">RSR</Link>
                <Link to="/sports-south" className="navbar-item">Sports South</Link>
                <Link to="/zanders" className="navbar-item">Zanders</Link>
              </div>
            </div>
          </div>

          <div className="navbar-end">
            {this.state.user ?
              <div className="navbar-item avatar-item">
                <figure className="image is-24x24">
                  <img className="is-rounded" src={this.state.user.avatar} alt={this.state.user.email} />
                </figure>
              </div> : <></>
            }
            <div className="navbar-item has-dropdown is-hoverable">
              <span className="navbar-link">{this.state.user ? this.state.user.email : "Account"}</span>
              <div className="navbar-dropdown">
                <span onClick={this.signOut} className="navbar-item">Sign Out</span>
              </div>
            </div>
          </div>
        </div>
      </nav>
    );
  }
}

export default Header;